import type { InputHTMLAttributes } from 'react';
import './Input.css';

export type InputProps = InputHTMLAttributes<HTMLInputElement>;

/**
 * Thin styled wrapper over the native <input>. No validation logic —
 * validation lives in the Domain layer of whichever feature uses this.
 */
export function Input({ className, ...rest }: InputProps) {
  const classes = ['dma-input', className].filter(Boolean).join(' ');
  return <input className={classes} {...rest} />;
}
